import { Box } from 'components'
import { SongList } from './song-list'
import { useEffect } from 'react'
import { useGetQuery, usePostQuery } from 'hooks'
import { useParams } from 'react-router-dom'
import { useSocket } from 'providers'

export const KaraokeQueue = ({ user, guest }) => {
  const { slug } = useParams()
  const socket = useSocket()

  const { data, error, setPath, reFetch } = useGetQuery({
    url: `/activity/karaoke/${slug}`
  })

  const { post: deleteSong } = usePostQuery({ method: 'DELETE', url: '' })

  const route = guest ? 'guest' : ''

  const handleDeleteSong = (yes, id) => {
    if (!yes) return
    deleteSong({}, `/${route}/queue_items/${id}`.replace('//', '/'))
    reFetch(true)
  }

  useEffect(() => {
    socket.on(`/karaoke/${slug}`, (res) => {
      reFetch(true)
    })
  }, [socket, slug])

  return (
    <Box>
      <SongList songs={data?.queue?.QueueItems} actor={user} onDelete={handleDeleteSong} />
    </Box>
  )
}
